module.exports = __webpack_public_path__ + "img/jo.51302798.svg";